import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGraphAuthStatus } from '../../../hooks/useGraphAuthStatus';
import { ShieldSecurityLinear } from '../../icons';
import { Button, DEFAULT_MODAL_WIDTH, Modal, Paragraph, type ModalProps } from '../../Ant';

const MESSAGE_ID = 'graph-reauth-message';

/**
 * antd pins the mask and wrapper to the viewport; absolute keeps them inside the container. The
 * page gutters sit outside the container, so the sides reach past it to the edges of the pane.
 */
const CONTAINED_OVERLAY_STYLE = {
  position: 'absolute',
  left: 'calc(var(--spacing-gutter) * -1)',
  right: 'calc(var(--spacing-gutter) * -1)',
} as const;

const CONTAINED_MODAL_STYLES: ModalProps['styles'] = {
  mask: CONTAINED_OVERLAY_STYLE,
  wrapper: CONTAINED_OVERLAY_STYLE,
};

const GraphReauthBanner = ({ container }: { container: HTMLElement }) => {
  const { t } = useTranslation();
  const { needsReauth, isReauthorizing, reauthorize } = useGraphAuthStatus();

  return (
    <Modal
      className="confirm-modal"
      open={needsReauth}
      getContainer={container}
      styles={CONTAINED_MODAL_STYLES}
      width={DEFAULT_MODAL_WIDTH}
      footer={null}
      centered
      closeIcon={null}
      maskClosable={false}
      keyboard={false}
      aria-labelledby={MESSAGE_ID}
      data-testid="graph-reauth-modal"
    >
      <Flex gap={15} vertical align="center">
        <div className="icon-container">
          <ShieldSecurityLinear />
        </div>
        <Flex gap={5} vertical align="center">
          <Paragraph $fontsize="14px" $weight={600} $color="title" $lineheight="21px">
            {t('common:graphReauthorization.title')}
          </Paragraph>
          <Paragraph
            id={MESSAGE_ID}
            $fontsize="13px"
            $color="description"
            $lineheight="20px"
            className="ta-center"
          >
            {t('common:graphReauthorization.message')}
          </Paragraph>
        </Flex>
        <Button type="primary" block size="large" loading={isReauthorizing} onClick={reauthorize}>
          {t('common:graphReauthorization.reauthorize')}
        </Button>
      </Flex>
    </Modal>
  );
};

export default GraphReauthBanner;
